import SwitchCheckbox from './SwitchCheckbox';

export { Props } from './SwitchCheckbox';
export default SwitchCheckbox;
